"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var H1_1 = require("./H1");
exports.default = H1_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/typography/H1/index.js
// module id = 547
// module chunks = 8